const INDENT_TYPE = "wix-rich-content-plugin-indent";
export {
  INDENT_TYPE
};
//# sourceMappingURL=types.js.map
